module.exports = __webpack_public_path__ + "static/img/areaFirst.9732df12.png";